export const PLAN_UPDATE_MODE_TYPES = {
  SHIFT_PLAN: 'shiftplan',
  WORK_PLAN: 'workplan',
} as const
